import { Category } from './category';
import { ProductChild } from './product-child';
import { ProductDiscount } from './product-discount';
import { Brand } from './brand';

export class Product {
    id = 0;
    category_id = 0;
    title = '';
    caption = '';
    caption_short = '';
    photos = [];
    ribbon = '';
    ribbon_style = '';
    status = 0;
    meta = '';
    extra = '';
    stock = 0;
    sales = 0;
    video = '';
    is_feature = 0;
    photo_feature = '';
    views = 0;
    discount_text = '';
    brand: Brand | null = null;

    category = new Category();
    childs = new Array<ProductChild>();
    discounts = new Array<ProductDiscount>();

    static getPrice(product: Product) {
        if(product.childs.length == 0){
            return 0;
        }
        if(product.discounts.length > 0){
            return product.childs[0].price - (product.childs[0].price * (product.discounts[0].percent)/100);
        }
        return product.childs[0].price;
    }

    static getPriceTwo(product: Product){
        if(product.childs.length == 0){
            return 0;
        }
        return product.childs[0].price_two;
    }

    static getPriceWithoutDiscount(product: Product) {
        if(product.childs.length == 0){
            return 0;
        }
        return product.childs[0].price;
    }

    static getDiscount(product: Product): string {
        if(product.discounts.length == 0){
            return '';
        }
        return product.discounts[0].percent + '% OFF - Sólo Venta Online';
    }

    static getStock(product: Product): number {
        if(product.childs.length == 0){
            return 0;
        }
        return product.childs[0].stock;
    }
}
